<div class="new-contract-hiring-data">
  <div class="new-contract-hiring-data__container-title ">
    <h2>{{ 'NEW_CONTRACT_LA.HIRING_DATA' | i18nextEager | uppercase }}</h2>
    <p class="new-contract-hiring-data__required">* {{ 'NEW_CONTRACT_LA.REQUIRED' | i18nextEager }}</p>
  </div>
  <section>
    <h2 class="new-contract-hiring-data__title">
      {{ 'NEW_CONTRACT_LA.HIRIN_PERIOD' | i18nextEager | uppercase }}
    </h2>
    <form [formGroup]="hiringDataForm" class="new-contract-hiring-data__form">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'NEW_CONTRACT_LA.START_CONTRACT' | i18nextEager }}</mat-label>
        <input
          matInput
          [matDatepicker]="startContract"
          formControlName="startContract"
          [min]="today"
          [max]="hiringDataForm.get('endContract').value"
          readonly
        />
        <img
          src="/assets/icons/calendar.svg"
          class="mat-datepicker-icon-personal"
          (click)="startContract.open()"
          alt="{{ 'COMMONS.CALENDAR' | i18nextEager }}"
        />
        <mat-datepicker #startContract></mat-datepicker>
        <mat-error
          *ngIf="
            hiringDataForm.get('startContract').errors?.required &&
            (hiringDataForm.get('startContract').touched || hiringDataForm.get('startContract').dirty)
          "
        >
          {{ 'COMMONS.REQUIRED_FIELD' | i18nextEager }}
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'NEW_CONTRACT_LA.END_CONTRACT' | i18nextEager }}</mat-label>
        <input
          matInput
          [matDatepicker]="endContract"
          formControlName="endContract"
          [min]="hiringDataForm.get('startContract').value"
          readonly
        />
        <img
          src="/assets/icons/calendar.svg"
          class="mat-datepicker-icon-personal"
          (click)="endContract.open()"
          alt="{{ 'COMMONS.CALENDAR' | i18nextEager }}"
        />
        <mat-datepicker #endContract></mat-datepicker>
        <mat-error
          *ngIf="
            hiringDataForm.get('endContract').errors?.required &&
            (hiringDataForm.get('endContract').touched || hiringDataForm.get('endContract').dirty)
          "
        >
          {{ 'COMMONS.REQUIRED_FIELD' | i18nextEager }}
        </mat-error>
      </mat-form-field>
    </form>
  </section>
  <section>
    <h2 class="new-contract-hiring-data__title">
      {{ 'NEW_CONTRACT_LA.DIRECTION' | i18nextEager | uppercase }}
    </h2>
    <form [formGroup]="hiringDataForm" class="new-contract-hiring-data__form">
      <div>
        <app-custom-select
          [label]="'NEW_CONTRACT_LA.VIA_TYPE'"
          [controlName]="'viaType'"
          [values]="viaTypesList"
          [required]="true"
          [searchBar]="true"
        ></app-custom-select>
        <mat-error
          *ngIf="
            hiringDataForm.get('viaType').errors?.required &&
            (hiringDataForm.get('viaType').touched || hiringDataForm.get('viaType').dirty)
          "
        >
          {{ 'COMMONS.REQUIRED_FIELD' | i18nextEager }}
        </mat-error>
      </div>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'NEW_CONTRACT_LA.ROAD_NAME' | i18nextEager }}</mat-label>
        <input matInput formControlName="roadName" required maxlength="50" />
        <mat-error
          *ngIf="
            hiringDataForm.get('roadName').errors?.required &&
            (hiringDataForm.get('roadName').touched || hiringDataForm.get('roadName').dirty)
          "
        >
          {{ 'COMMONS.REQUIRED_FIELD' | i18nextEager }}
        </mat-error>
      </mat-form-field>
      <div class="tree-col">
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_CONTRACT_LA.ADDRESS_NUMBER' | i18nextEager }}</mat-label>
            <input matInput formControlName="number" maxlength="8" alphanumeric />
            <mat-error
              *ngIf="
                hiringDataForm.get('number').errors?.maxlength &&
                (hiringDataForm.get('number').touched || hiringDataForm.get('number').dirty)
              "
            >
              {{ 'NEW_CONTRACTS.EIGHT_CHARACTERS_ERROR' | i18nextEager }}
            </mat-error>
            <mat-error
              *ngIf="
                !hiringDataForm.get('number').errors?.maxlength &&
                hiringDataForm.get('number').errors?.invalidInitialValue &&
                (hiringDataForm.get('number').touched || hiringDataForm.get('number').dirty)
              "
            >
              {{ 'NEW_CONTRACTS.INVALID_CHARACTER_ERROR' | i18nextEager }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_CONTRACT_LA.ADDRESS_GATE' | i18nextEager }}</mat-label>
            <input matInput formControlName="gate" maxlength="10" />
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_CONTRACT_LA.ADDRESS_STAIR' | i18nextEager }}</mat-label>
            <input matInput formControlName="stair" maxlength="3" alphanumeric />
            <mat-error
              *ngIf="
                hiringDataForm.get('stair').errors?.maxlength &&
                (hiringDataForm.get('stair').touched || hiringDataForm.get('stair').dirty)
              "
            >
              {{ 'NEW_CONTRACTS.THREE_CHARACTERS_ERROR' | i18nextEager }}
            </mat-error>
            <mat-error
              *ngIf="
                !hiringDataForm.get('stair').errors?.maxlength &&
                hiringDataForm.get('stair').errors?.invalidInitialValue &&
                (hiringDataForm.get('stair').touched || hiringDataForm.get('stair').dirty)
              "
            >
              {{ 'NEW_CONTRACTS.INVALID_CHARACTER_ERROR' | i18nextEager }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="tree-col">
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_CONTRACT_LA.ADDRESS_FLOOR' | i18nextEager }}</mat-label>
            <input matInput formControlName="floor" maxlength="3" alphanumeric />
            <mat-error
              *ngIf="
                hiringDataForm.get('floor').errors?.maxlength &&
                (hiringDataForm.get('floor').touched || hiringDataForm.get('floor').dirty)
              "
            >
              {{ 'NEW_CONTRACTS.THREE_CHARACTERS_ERROR' | i18nextEager }}
            </mat-error>
            <mat-error
              *ngIf="
                !hiringDataForm.get('floor').errors?.maxlength &&
                hiringDataForm.get('floor').errors?.invalidInitialValue &&
                (hiringDataForm.get('floor').touched || hiringDataForm.get('floor').dirty)
              "
            >
              {{ 'NEW_CONTRACTS.INVALID_CHARACTER_ERROR' | i18nextEager }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_CONTRACT_LA.ADDRESS_DOOR' | i18nextEager }}</mat-label>
            <input matInput formControlName="door" maxlength="3" alphanumeric />
            <mat-error
              *ngIf="
                hiringDataForm.get('door').errors?.maxlength &&
                (hiringDataForm.get('door').touched || hiringDataForm.get('door').dirty)
              "
            >
              {{ 'NEW_CONTRACTS.THREE_CHARACTERS_ERROR' | i18nextEager }}
            </mat-error>
            <mat-error
              *ngIf="
                !hiringDataForm.get('door').errors?.maxlength &&
                hiringDataForm.get('door').errors?.invalidInitialValue &&
                (hiringDataForm.get('door').touched || hiringDataForm.get('door').dirty)
              "
            >
              {{ 'NEW_CONTRACTS.INVALID_CHARACTER_ERROR' | i18nextEager }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_CONTRACT_LA.POSTAL_CODE' | i18nextEager }}</mat-label>
            <input matInput formControlName="postalCode" numeric maxlength="5" required />
            <mat-error
              *ngIf="
                hiringDataForm.get('postalCode').errors?.required &&
                (hiringDataForm.get('postalCode').touched || hiringDataForm.get('postalCode').dirty)
              "
            >
              {{ 'COMMONS.REQUIRED_FIELD' | i18nextEager }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <mat-form-field appearance="outline" *ngIf="townList?.length <= 1">
        <mat-label>{{ 'NEW_CONTRACT_LA.TOWN' | i18nextEager }}</mat-label>
        <input matInput formControlName="town" maxlength="50" required />
        <mat-error
          *ngIf="
            hiringDataForm.get('town').errors?.required &&
            (hiringDataForm.get('town').touched || hiringDataForm.get('town').dirty)
          "
        >
          {{ 'COMMONS.REQUIRED_FIELD' | i18nextEager }}
        </mat-error>
      </mat-form-field>
      <app-custom-select
        *ngIf="townList?.length > 1"
        [label]="'NEW_CONTRACT_LA.TOWN'"
        [controlName]="'town'"
        [values]="townList"
      >
        <mat-error
          *ngIf="
            hiringDataForm.get('town').errors?.required &&
            (hiringDataForm.get('town').touched || hiringDataForm.get('town').dirty)
          "
        >
          {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
        </mat-error>
      </app-custom-select>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'NEW_CONTRACT_LA.PROVINCE' | i18nextEager }}</mat-label>
        <input
          matInput
          formControlName="province"
          maxlength="50"
          placeholder="{{ 'NEW_CONTRACT_LA.PROVINCE_PLACEHOLDER' | i18nextEager }}"
        />
        <mat-error
          *ngIf="
            hiringDataForm.get('province').errors?.required &&
            (hiringDataForm.get('province').touched || hiringDataForm.get('province').dirty)
          "
        >
          {{ 'COMMONS.REQUIRED_FIELD' | i18nextEager }}
        </mat-error>
      </mat-form-field>
    </form>
  </section>
  <section>
    <h2 class="new-contract-hiring-data__title">{{ 'NEW_CONTRACT_LA.BANK_ACCOUNT' | i18nextEager | uppercase }} *</h2>
    <form [formGroup]="hiringDataForm" class="new-contract-hiring-data__form">
      <div class="new-contract-hiring-data__account">
        <mat-form-field appearance="outline" id="iban">
          <mat-label>{{ 'NEW_CONTRACTS.IBAN' | i18nextEager }}</mat-label>
          <input matInput formControlName="iban" maxlength="4" uppercase />
        </mat-form-field>
        <mat-form-field appearance="outline" id="entity">
          <mat-label>{{ 'NEW_CONTRACTS.ENTITY' | i18nextEager }}</mat-label>
          <input matInput formControlName="entity" maxlength="4" numeric />
        </mat-form-field>
        <mat-form-field appearance="outline" id="office">
          <mat-label>{{ 'NEW_CONTRACTS.OFFICE' | i18nextEager }}</mat-label>
          <input matInput formControlName="office" maxlength="4" numeric />
        </mat-form-field>
        <mat-form-field appearance="outline" id="dc">
          <mat-label>{{ 'NEW_CONTRACTS.DC' | i18nextEager }}</mat-label>
          <input matInput formControlName="dc" maxlength="2" numeric />
        </mat-form-field>
        <mat-form-field appearance="outline" id="account">
          <mat-label>{{ 'NEW_CONTRACTS.ACCOUNT' | i18nextEager }}</mat-label>
          <input matInput formControlName="account" maxlength="10" numeric />
        </mat-form-field>
      </div>
      <div
        class="new-contract-hiring-data__account-error"
        *ngIf="
          hiringDataForm?.hasError('invalid_IBAN') &&
          (hiringDataForm.get('iban').touched ||
            hiringDataForm.get('iban').dirty ||
            hiringDataForm.get('entity').touched ||
            hiringDataForm.get('entity').dirty ||
            hiringDataForm.get('office').touched ||
            hiringDataForm.get('office').dirty ||
            hiringDataForm.get('dc').touched ||
            hiringDataForm.get('dc').dirty ||
            hiringDataForm.get('account').touched ||
            hiringDataForm.get('account').dirty)
        "
      >
        <mat-error>
          {{ 'NEW_CONTRACTS.IBAN_ERROR' | i18nextEager }}
        </mat-error>
      </div>
    </form>
  </section>
  <section class="new-contract-hiring-data__section">
    <h2 class="new-contract-hiring-data__title">
      {{ 'NEW_CONTRACT_LA.SIGNER_DATA' | i18nextEager | uppercase }}
    </h2>
    <form
      [formGroup]="hiringDataForm"
      class="new-contract-hiring-data__form new-contract-hiring-data__form--margin-bottom"
    >
      <mat-form-field appearance="outline">
        <mat-label>{{ 'NEW_CONTRACT_LA.NAME' | i18nextEager }}</mat-label>
        <input matInput formControlName="name" maxlength="50" required />
        <mat-error
          *ngIf="
            hiringDataForm.get('name').errors?.required &&
            (hiringDataForm.get('name').touched || hiringDataForm.get('name').dirty)
          "
        >
          {{ 'COMMONS.REQUIRED_FIELD' | i18nextEager }}
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'NEW_CONTRACT_LA.SURNAME' | i18nextEager }}</mat-label>
        <input matInput formControlName="surname" maxlength="50" required />
        <mat-error
          *ngIf="
            hiringDataForm.get('surname').errors?.required &&
            (hiringDataForm.get('surname').touched || hiringDataForm.get('surname').dirty)
          "
        >
          {{ 'COMMONS.REQUIRED_FIELD' | i18nextEager }}
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'NEW_CONTRACT_LA.DNI' | i18nextEager }}</mat-label>
        <input matInput formControlName="dni" maxlength="9" placeholder="Ej. 00000000A" required />
        <mat-error
          *ngIf="
            hiringDataForm.get('dni').errors?.required &&
            (hiringDataForm.get('dni').touched || hiringDataForm.get('dni').dirty)
          "
        >
          {{ 'COMMONS.REQUIRED_FIELD' | i18nextEager }}
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'NEW_CONTRACT_LA.EMAIL' | i18nextEager }}</mat-label>
        <input matInput formControlName="email" placeholder="samplemail@mail.com" maxlength="50" required />
        <mat-error
          *ngIf="
            hiringDataForm.get('email').errors?.required &&
            (hiringDataForm.get('email').touched || hiringDataForm.get('email').dirty)
          "
        >
          {{ 'COMMONS.REQUIRED_FIELD' | i18nextEager }}
        </mat-error>
        <mat-error
          *ngIf="
            hiringDataForm.get('email').errors &&
            hiringDataForm.get('email').value &&
            (hiringDataForm.get('email').touched || hiringDataForm.get('email').dirty)
          "
        >
          {{ 'NEW_CONTRACTS.EMAIL_ERROR' | i18nextEager }}
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'NEW_CONTRACT_LA.PHONE' | i18nextEager }}</mat-label>
        <input matInput formControlName="phone" maxlength="9" numeri required />
        <mat-error
          *ngIf="
            hiringDataForm.get('phone').errors?.required &&
            (hiringDataForm.get('phone').touched || hiringDataForm.get('phone').dirty)
          "
        >
          {{ 'COMMONS.REQUIRED_FIELD' | i18nextEager }}
        </mat-error>
      </mat-form-field>
    </form>
    <button class="secondary new-contract-hiring-data__button" (click)="handleAddSigner()">
      {{ 'USER_MANAGEMENT.ADD_SIGNER' | i18nextEager }}
      <img src="/assets/icons/plus.svg" alt="{{ 'COMMONS.ADD' | i18nextEager }}" />
    </button>
  </section>
  <section *ngIf="secondSigner" class="new-contract-hiring-data__section">
    <div class="new-contract-hiring-data__title-section-container">
      <h2 class="new-contract-hiring-data__title-section">
        {{ 'NEW_CONTRACT_LA.SIGNER_DATA' | i18nextEager | uppercase }} II
      </h2>
      <img
        src="/assets/icons/deleteRed.svg"
        class="new-contract-hiring-data__cursor-pointer"
        alt="{{ 'COMMONS.REMOVE' | i18nextEager }}"
        (click)="handleDeleteSigner()"
      />
    </div>
    <form
      [formGroup]="hiringDataForm"
      class="new-contract-hiring-data__form new-contract-hiring-data__form--margin-bottom"
    >
      <mat-form-field appearance="outline">
        <mat-label>{{ 'NEW_CONTRACT_LA.NAME' | i18nextEager }}</mat-label>
        <input matInput formControlName="name2" maxlength="50" required />
        <mat-error
          *ngIf="
            hiringDataForm.get('name2').errors?.required &&
            (hiringDataForm.get('name2').touched || hiringDataForm.get('name2').dirty)
          "
        >
          {{ 'COMMONS.REQUIRED_FIELD' | i18nextEager }}
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'NEW_CONTRACT_LA.SURNAME' | i18nextEager }}</mat-label>
        <input matInput formControlName="surname2" maxlength="50" required />
        <mat-error
          *ngIf="
            hiringDataForm.get('surname2').errors?.required &&
            (hiringDataForm.get('surname2').touched || hiringDataForm.get('surname2').dirty)
          "
        >
          {{ 'COMMONS.REQUIRED_FIELD' | i18nextEager }}
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'NEW_CONTRACT_LA.DNI' | i18nextEager }}</mat-label>
        <input matInput formControlName="dni2" maxlength="9" required />
        <mat-error
          *ngIf="
            hiringDataForm.get('dni2').errors?.required &&
            (hiringDataForm.get('dni2').touched || hiringDataForm.get('dni2').dirty)
          "
        >
          {{ 'COMMONS.REQUIRED_FIELD' | i18nextEager }}
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'NEW_CONTRACT_LA.EMAIL' | i18nextEager }}</mat-label>
        <input matInput formControlName="email2" maxlength="50" required />
        <mat-error
          *ngIf="
            hiringDataForm.get('email2').errors?.required &&
            (hiringDataForm.get('email2').touched || hiringDataForm.get('email2').dirty)
          "
        >
          {{ 'COMMONS.REQUIRED_FIELD' | i18nextEager }}
        </mat-error>
        <mat-error
          *ngIf="
            hiringDataForm.get('email2').errors &&
            hiringDataForm.get('email2').value &&
            (hiringDataForm.get('email2').touched || hiringDataForm.get('email2').dirty)
          "
        >
          {{ 'NEW_CONTRACTS.EMAIL_ERROR' | i18nextEager }}
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'NEW_CONTRACT_LA.PHONE' | i18nextEager }}</mat-label>
        <input matInput formControlName="phone2" maxlength="9" numeric required />
        <mat-error
          *ngIf="
            hiringDataForm.get('phone2').errors?.required &&
            (hiringDataForm.get('phone2').touched || hiringDataForm.get('phone2').dirty)
          "
        >
          {{ 'COMMONS.REQUIRED_FIELD' | i18nextEager }}
        </mat-error>
      </mat-form-field>
    </form>
  </section>
</div>
